import { createSharedStoreHook } from 'shared-store-hook';

// Business identity. business_official_name is the IRS-registered legal entity
// (EIN holder) and must match the carrier SMS registration exactly;
// business_display_name is the trade name the site markets under.
export const useConfig = createSharedStoreHook({
  initialState: {
    business_official_name: '10 Space LLC',
    business_display_name: 'Tenspace Software',
    contact_phone: '505-600-1741',
    contact_email: 'support@10spacesoftware.com',
    contact_address: '603 S Public RD Unit 801, Lafayette, CO 80026',
  },
});
